import React from 'react'
import {useSelector,useDispatch} from "react-redux";
import {actionsState as projectState} from '../Redux/project'
import {getStrLang, is_touch_device} from "../Helpers/functions";
import {sendRedrawSimpleEvent, sendUnselectEvent} from "../Helpers/Events";
const Control = ()=>{

    const dispatch = useDispatch();
    const planeEdit = useSelector(state=>state.project.planeEdit);
    const editMode = useSelector(state=>state.project.editMode);

    const setPlanEdit = ()=>{
        if(!planeEdit){
            dispatch(projectState.setModal(''));
            dispatch(projectState.showPlaneEdit(true));
        }
    };

    const setThreeView = ()=>{
        if(planeEdit){
            dispatch(projectState.setModal(''));
            dispatch(projectState.showPlaneEdit(false));
        }
    };
    const toggleEditMode = ()=>{
        dispatch(projectState.setModal(''));
        dispatch(projectState.setEditMode(!editMode));

        if (editMode) {
            sendUnselectEvent(document.querySelector('#plan'));
            sendRedrawSimpleEvent(document.querySelector('#plan'));
        }
    }
    const setModulesModal = ()=>{
        dispatch(projectState.setModal('modules'));
    }
    if (window.conf_nofunc) {
        return <div className="control">
            <div
                className={planeEdit ? 'control__item control__item_active' : 'control__item'}
                onClick={() => {
                    setPlanEdit()
                }}>
                <div className="tooltip tooltip-top">{ getStrLang('c3d_IQBhp') }</div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                    <g fill="currentColor">
                        <path
                            d="M40.5,41.5h-30c-0.55,0-1-0.45-1-1v-30c0-0.55,0.45-1,1-1h30c0.55,0,1,0.45,1,1v30      C41.5,41.05,41.05,41.5,40.5,41.5z M11.5,39.5h28v-28h-28V39.5z"/>
                    </g>
                </svg>
            </div>
            <div
                className={planeEdit ? 'control__item' : 'control__item  control__item_active'}
                onClick={() => {
                    setThreeView()
                }}>
                <div className="tooltip tooltip-top">{ getStrLang('c3d_NmKbP') }</div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                    <g fill="currentColor">
                        <path
                            d="M41.96,14.61c0-0.03-0.01-0.05-0.01-0.08c-0.01-0.1-0.04-0.19-0.08-0.27c-0.01-0.02-0.01-0.04-0.02-0.06    c-0.05-0.1-0.12-0.19-0.2-0.26c-0.02-0.02-0.04-0.03-0.06-0.05c-0.03-0.03-0.06-0.06-0.1-0.08c-0.05-0.03-0.11-0.05-0.16-0.07    c-0.01-0.01-0.02-0.02-0.04-0.02L25.82,8.55c-0.21-0.07-0.43-0.07-0.63,0L9.71,13.71c-0.01,0-0.02,0.02-0.04,0.02    c-0.05,0.02-0.11,0.04-0.16,0.07c-0.04,0.02-0.07,0.05-0.1,0.08c-0.02,0.02-0.04,0.03-0.06,0.05c-0.08,0.08-0.15,0.17-0.2,0.26    c-0.01,0.02-0.02,0.04-0.02,0.06c-0.04,0.09-0.06,0.18-0.08,0.27c0,0.03-0.01,0.05-0.01,0.08c0,0.02-0.01,0.03-0.01,0.05v19.08    c0,0.36,0.19,0.69,0.51,0.87l15.47,8.77c0.05,0.03,0.11,0.05,0.17,0.07c0.02,0.01,0.05,0.02,0.07,0.03    c0.08,0.02,0.17,0.03,0.26,0.03s0.17-0.01,0.26-0.03c0.02-0.01,0.05-0.02,0.07-0.03c0.06-0.02,0.11-0.04,0.17-0.07l15.47-8.77    c0.31-0.18,0.51-0.51,0.51-0.87V14.66C41.97,14.64,41.96,14.62,41.96,14.61z M25.5,10.55l12.94,4.31l-12.94,6.9l-12.94-6.9    L25.5,10.55z M11.03,16.32l13.47,7.18v17.28l-13.47-7.63V16.32z M39.97,33.15L26.5,40.78V23.51l13.47-7.18V33.15z"/>
                    </g>
                </svg>
            </div>
        </div>
    } else {
        return <div className="control">
            <div className={planeEdit?'control__item control__item_active':'control__item'} onClick={()=>{setPlanEdit()}}>
                <div className="tooltip tooltip-top">{ getStrLang('c3d_IQBhp') }</div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                    <g fill="currentColor">
                        <path d="M40.5,41.5h-30c-0.55,0-1-0.45-1-1v-30c0-0.55,0.45-1,1-1h30c0.55,0,1,0.45,1,1v30      C41.5,41.05,41.05,41.5,40.5,41.5z M11.5,39.5h28v-28h-28V39.5z"/>
                    </g>
                </svg>
            </div>
            <div className={planeEdit?'control__item':'control__item  control__item_active'} onClick={()=>{setThreeView()}}>
                <div className="tooltip tooltip-top">{ getStrLang('c3d_NmKbP') }</div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                    <g fill="currentColor">
                        <path d="M41.96,14.61c0-0.03-0.01-0.05-0.01-0.08c-0.01-0.1-0.04-0.19-0.08-0.27c-0.01-0.02-0.01-0.04-0.02-0.06    c-0.05-0.1-0.12-0.19-0.2-0.26c-0.02-0.02-0.04-0.03-0.06-0.05c-0.03-0.03-0.06-0.06-0.1-0.08c-0.05-0.03-0.11-0.05-0.16-0.07    c-0.01-0.01-0.02-0.02-0.04-0.02L25.82,8.55c-0.21-0.07-0.43-0.07-0.63,0L9.71,13.71c-0.01,0-0.02,0.02-0.04,0.02    c-0.05,0.02-0.11,0.04-0.16,0.07c-0.04,0.02-0.07,0.05-0.1,0.08c-0.02,0.02-0.04,0.03-0.06,0.05c-0.08,0.08-0.15,0.17-0.2,0.26    c-0.01,0.02-0.02,0.04-0.02,0.06c-0.04,0.09-0.06,0.18-0.08,0.27c0,0.03-0.01,0.05-0.01,0.08c0,0.02-0.01,0.03-0.01,0.05v19.08    c0,0.36,0.19,0.69,0.51,0.87l15.47,8.77c0.05,0.03,0.11,0.05,0.17,0.07c0.02,0.01,0.05,0.02,0.07,0.03    c0.08,0.02,0.17,0.03,0.26,0.03s0.17-0.01,0.26-0.03c0.02-0.01,0.05-0.02,0.07-0.03c0.06-0.02,0.11-0.04,0.17-0.07l15.47-8.77    c0.31-0.18,0.51-0.51,0.51-0.87V14.66C41.97,14.64,41.96,14.62,41.96,14.61z M25.5,10.55l12.94,4.31l-12.94,6.9l-12.94-6.9    L25.5,10.55z M11.03,16.32l13.47,7.18v17.28l-13.47-7.63V16.32z M39.97,33.15L26.5,40.78V23.51l13.47-7.18V33.15z"/>
                    </g>
                </svg>
            </div>
            {planeEdit === true && (<div
                className={editMode?'control-hint active':'control-hint'}
                onClick={()=>{toggleEditMode()}}>
                <span className={!is_touch_device()?'active':''}>{ getStrLang('c3d_Crwnt') }</span>
                <span className={is_touch_device()?'active':''}>{ getStrLang('c3d_7G3gP') }</span>
            </div>)}
            {planeEdit === true && (<>
                {/*<div className={editMode?'control-hint active':'control-hint'}>Для прекращения рисования стен нажмите правую кнопку мыши</div>*/}
                <div className='control__item' disable="true">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                        <g fill="currentColor">
                            <path d="M25.0,0.0 H28.0 V51.0 H25.0 Z"/>
                        </g>
                    </svg>
                </div>

                <div className={editMode?'control__item control__item_active':'control__item'} onClick={toggleEditMode}>
                    <div className="tooltip tooltip-top">{ getStrLang('c3d_2FcWJ') }</div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                        <g fill="currentColor">
                            <path d="M39.5,37.26a3.5,3.5,0,0,0-3.34,2.5H14.84a3.5,3.5,0,0,0-2.34-2.34V15.59a3.5,3.5,0,1,0-2,0V37.42a3.49,3.49,0,1,0,4.34,4.34H36.16a3.49,3.49,0,1,0,3.34-4.5ZM10,12.26a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,10,12.26Zm1.5,30a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,11.5,42.26Zm28,0a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,39.5,42.26Z"/>
                            <path d="M20.08,32.68a1,1,0,0,0,.37-.08l7.07-2.82h0a1,1,0,0,0,.29-.19l0,0L42.71,14.71a1,1,0,0,0,0-1.42L38.46,9.05a1,1,0,0,0-1.41,0L22.2,23.9l0,0a.91.91,0,0,0-.19.29h0L19.15,31.3a1,1,0,0,0,.22,1.08A1,1,0,0,0,20.08,32.68ZM37.76,11.17,40.59,14,27.15,27.43,24.32,24.6ZM23.27,26.38l2.1,2.1-3.5,1.4Z"/>
                        </g>
                    </svg>
                </div>

                <div className='control__item' onClick={()=>{setModulesModal()}}>
                    <div className="tooltip tooltip-top">{ getStrLang('c3d_K8BPR') }</div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                        <g fill="currentColor">
                            <path d="M41,43.76a1,1,0,0,1-1-1V38.89a1,1,0,0,1,2,0v3.87A1,1,0,0,1,41,43.76Z"/>
                            <path d="M10.68,43.76a1,1,0,0,1-1-1V38.89a1,1,0,0,1,2,0v3.87A1,1,0,0,1,10.68,43.76Z"/>
                            <path d="M42.6,39.87H9.09a1,1,0,0,1-1-1V36.3a1,1,0,0,1,1-1H42.6a1,1,0,0,1,1,1v2.57A1,1,0,0,1,42.6,39.87Zm-32.51-2H41.6V37.3H10.09Z"/>
                            <path d="M17.34,29.44H9.09a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1h3.58a5.67,5.67,0,0,1,5.67,5.67v2.75A1,1,0,0,1,17.34,29.44Zm-7.25-2h6.25V25.69A3.67,3.67,0,0,0,12.67,22H10.09Z"/>
                            <path d="M42.6,29.44H34.36a1,1,0,0,1-1-1V25.69A5.67,5.67,0,0,1,39,20H42.6a1,1,0,0,1,1,1v7.42A1,1,0,0,1,42.6,29.44Zm-7.24-2H41.6V22H39a3.67,3.67,0,0,0-3.67,3.67Z"/>
                            <path d="M40,22a1,1,0,0,1-1-1V13.33a1.57,1.57,0,0,0-1.58-1.57H14.25a1.57,1.57,0,0,0-1.58,1.57V21a1,1,0,0,1-2,0V13.33a3.57,3.57,0,0,1,3.58-3.57h23.2A3.58,3.58,0,0,1,41,13.33V21A1,1,0,0,1,40,22Z"/>
                            <path d="M42.6,39.87H9.09a1,1,0,0,1-1-1V28.56a1,1,0,0,1,1-1H42.6a1,1,0,0,1,1,1V38.87A1,1,0,0,1,42.6,39.87Zm-32.51-2H41.6V29.56H10.09Z"/>
                        </g>
                    </svg>
                </div>
            </>)}
        </div>
    }
};
;

export default Control;

